import { Button } from "components/atoms/Button";
import {
  Dropdown,
  DropdownMenu,
  DropdownMenuItem,
  DropdownToggle,
} from "components/molecules/Dropdown";
import { DropdownMenuGroup } from "components/molecules/Dropdown/DropdownMenuGroup";
import { ShipmentTypes } from "enum/shipment-types.enum";
import { FaBoxOpen, FaPoundSign, FaUpload, FaBox } from "react-icons/fa";
import { ReactNode } from "react";
import { Portal } from "react-portal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { setFormType } from "store/createShipmentSlice/index.slice";
import { openModal } from "store/modalSlice";
import { PermissionCheck } from "utils/PermissionCheck/PermissionCheck";
import { PICKUP_ELIGIBLE_API_PATHS } from "constants/pickup-eligible-carriers.const";

/**
 * The "Create new" menu. `toggle` swaps the default primary button for a
 * different trigger (the phone header uses a plus icon button) while keeping
 * the exact same menu items and permission gating.
 */
export const NavigationCreateDropdown = ({
  toggle,
}: {
  toggle?: ReactNode;
} = {}) => {
  const dispatch = useDispatch();

  const { loggedInUser } = useSelector((state: RootState) => {
    return state.authSlice;
  });

  const permissions = new PermissionCheck({ user: loggedInUser });

  const { shippingWhitelists } = useSelector((state: RootState) => {
    return state.shippingWhitelistsSlice;
  });

  const containsUpsOrFedex = [];
  const containsDeutschePost = [];
  shippingWhitelists.forEach((element) => {
    if (PICKUP_ELIGIBLE_API_PATHS.includes(element.supplier.apiPath)) {
      containsUpsOrFedex.push(element);
    }

    if (
      element.carrierId === "58" //staging deutsche post
    ) {
      containsDeutschePost.push(element);
    }
  });

  return (
    <Dropdown mode="onClick" placement="bottom-end">
      <DropdownToggle>
        {toggle ?? <Button colorScheme="primary">Create new</Button>}
      </DropdownToggle>
      <Portal>
        <DropdownMenu width={240}>
          <DropdownMenuGroup>
            {permissions.shipments.canCreate() && (
              <DropdownMenuItem
                icon={FaBoxOpen}
                onClick={() => {
                  dispatch(setFormType(ShipmentTypes.SHIPMENT));
                  dispatch(openModal({ name: "createShipment" }));
                }}
              >
                Shipment
              </DropdownMenuItem>
            )}
            {permissions.quotes.canCreate() && (
              <DropdownMenuItem
                icon={FaPoundSign}
                onClick={() => {
                  dispatch(setFormType(ShipmentTypes.QUOTE));
                  dispatch(openModal({ name: "createShipment" }));
                }}
              >
                Quote
              </DropdownMenuItem>
            )}
            {permissions.bulkShipments.canCreate() && (
              <DropdownMenuItem
                icon={FaUpload}
                onClick={() => {
                  dispatch(openModal({ name: "createBulkShipment" }));
                }}
              >
                Bulk shipments upload
              </DropdownMenuItem>
            )}
            {permissions.pickup.canCreate() && containsUpsOrFedex.length ? (
              <DropdownMenuItem
                icon={FaBox}
                onClick={() => {
                  dispatch(openModal({ name: "pickUpModal" }));
                }}
              >
                Pick up
              </DropdownMenuItem>
            ) : null}

            {containsDeutschePost.length ? (
              <DropdownMenuItem
                icon={FaBox}
                onClick={() => {
                  dispatch(openModal({ name: "pickUpModal" }));
                }}
              >
                Deutsche Post Manifest
              </DropdownMenuItem>
            ) : null}
          </DropdownMenuGroup>
        </DropdownMenu>
      </Portal>
    </Dropdown>
  );
};
